import { defineComponent } from 'vue';
import BaseSocials from '../../mixins/BaseSocial/BaseSocial.js';
import getSerialisedParams from '../../utils/getSerialisedParams.js';

/**
 * Hey!
 *
 * SFacebookWorkplace component used for FacebookWorkplace social network
 * @link https://work.facebook.com/
 * @example https://work.facebook.com/sharer.php?url=https%253A%252F%252Fgithub.com
 */
/**
 * Share parameters for link
 * @link https://developers.facebook.com/docs/workplace/sharing/share-dialog/
 */

var SFacebookWorkplace = /* #__PURE__ */defineComponent({
  name: 'SFacebookWorkplace',
  mixins: [BaseSocials('Facebook Workplace')],
  computed: {
    networkURL: function networkURL() {
      var BASE_URL = 'https://work.facebook.com/sharer.php';
      var shareOptions = this.shareOptions;
      var url = shareOptions.url;
      var serialisedParams = getSerialisedParams({
        url: url
      });
      return "".concat(BASE_URL).concat(serialisedParams);
    }
  },
  render: function render() {
    return this.generateComponent(this.networkURL);
  }
});

export default SFacebookWorkplace;
